export default __webpack_public_path__ + "static/media/clean-teeth-video-bg.32c3631e.png";